import { cn } from '~/chords/lib/cn';

export const SLIDE_OUT_STATUSES = [
  'isClosed',
  'isClosing',
  'isOpening',
  'isOpen',
] as const;

export const OVERLAY_CLASS = {
  show: cn('animate-dialog-overlay-show'),
  hide: cn('animate-dialog-overlay-hide'),
} as const;

export const CONTENT_CLASS = {
  show: cn('translate-x-0'),
  disable: cn('!pointer-events-none'),
} as const;

export const DEFAULT_CONTENT_WIDTH = '400px';

export const ANIMATION_DURATION = 300;
